import React, { useState, useEffect } from 'react';

function InputSj({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [kdRekanan, setKdRekanan] = useState('');
  const [namarekanan, setNamarekanan] = useState('');
  const [nodo, setNodo] = useState('');
  const [sopir, setSopir] = useState('');
  const [kotaAsal, setKotaAsal] = useState('');
  const [kotaTujuan, setKotaTujuan] = useState('');
  const [keterangan, setKeterangan] = useState('');
  const [status, setStatus] = useState('');
  const [lstatus, setLstatus] = useState('');
  const [namaTtd1, setNamaTtd1] = useState('');
  const [detailBarang, setDetailBarang] = useState([]);
  const [idUser, setIdUser] = useState('');

  const schema = localStorage.getItem('schema');

  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];

    if (editMode && pasang) {
      const { master, details } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setKdRekanan(master.KD_REKANAN || '');
      setNamarekanan(master.NAMAREKANAN || '');
      setNodo(master.NO_DO || '');
      setSopir(master.SOPIR || '');
      setKotaAsal(master.KOTA_ASAL || '');
      setKotaTujuan(master.KOTA_TUJUAN || '');
      setKeterangan(master.KETERANGAN || '');
      setStatus(master.STATUS || '');
      setLstatus(master.LSTATUS || '');
      setNamaTtd1(master.NAMA_TTD1 || '');

      if (details && Array.isArray(details)) {
        const withNomor = details.map((item, idx) => ({
          NOMOR: idx + 1,
          NO_SJ: item.NO_SJ || '',
          NO_SHIPMENT: item.NO_SHIPMENT || '',
          TGL_SJ: formatDateForInput(item.TGL_SJ),
          TGL_MASUK: formatDateForInput(item.TGL_MASUK),
          TGL_BONGKAR: formatDateForInput(item.TGL_BONGKAR),
          BERAT: item.BERAT ?? '',
          KUBIK: item.KUBIK ?? '',
          KARTON: item.KARTON ?? '',
        }));
        setDetailBarang(withNomor);
      } else {
        setDetailBarang([]);
      }
    } else if (pasang?.isNew) {
      setNoTransaksi(0);
      setTglTransaksi(formattedToday);
    }

    const idUser = localStorage.getItem('id_user') || '';
    setIdUser(idUser);
  }, [editMode, pasang]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleDetailChange = (index, field, value) => {
    const updated = [...detailBarang];
    updated[index][field] = value;
    setDetailBarang(updated);
  };

  const handleValidasi = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'sj');
      formData.append('id', id);
      formData.append('schema', schema);
      formData.append('id_user', idUser);
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sj.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status !== 'success') {
        alert(`Gagal validasi master: ${result.message}`);
        return;
      }

      onSave();
    } catch (err) {
      console.error('Error saat validasi SJ:', err);
      alert('Terjadi kesalahan saat menyimpan SJ dan detail.');
    }
  };

  const handleUnvalid = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'sj_unvalid');
      formData.append('id', id);
      formData.append('schema', schema);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sj.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setStatus('0');
        alert('SJ berhasil unvalid');
      } else {
        alert(`Gagal validasi: ${result.message}`);
      }
    } catch (err) {
      console.error('Validasi error:', err);
      alert('Terjadi kesalahan saat validasi SJ.');
    }
  };

  const handleDelete = async () => {
    const id = noTransaksi || '0';

    try {
      const formData = new URLSearchParams();
      formData.append('caller', 'sj_hapus');
      formData.append('id', id);
      formData.append('schema', schema);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sj.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      const result = await response.json();

      if (result.status === 'success') {
        alert('SJ berhasil dihapus');
        onSave();
      } else {
        alert(`Gagal validasi: ${result.message}`);
      }
    } catch (err) {
      console.error('Validasi error:', err);
      alert('Terjadi kesalahan saat hapus SJ.');
    }
  };

  const isLocked = ['5', '6', '9'].includes(status);

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

      <div>
        <label><strong>No Transaksi</strong></label>
            <input type="text" readOnly value={noTransaksi}
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
            />
          </div>

          <div>
            <label><strong>Tanggal</strong></label>
            <input type="date" value={tglTransaksi} onChange={(e) => setTglTransaksi(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px', borderRadius: '5px', marginBottom: 10 }}
            />
          </div>

          <div style={{ marginBottom: '10px' }}>
            <label>Rekanan</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input type="text" value={kdRekanan} readOnly style={{ width: '100px', padding: '5px', backgroundColor: '#E6E6E6' }} />
              <input type="text" value={namarekanan} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6' }} />
            </div>
          </div>

          <div style={{ marginBottom: '10px' }}>
            <label>Sopir</label>
            <div style={{ display: 'flex', gap: '5px' }}>
              <input type="text" value={sopir} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6' }} />
            </div>
          </div>

          <div>
            <label><strong>No Do</strong></label>
            <input type="text" readOnly value={nodo}
              style={{ width: '100%', boxSizing: 'border-box', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
            />
          </div>

          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <div style={{ flex: 1 }}>
              <label><strong>Kota Asal</strong></label>
              <input type="text" readOnly value={kotaAsal} style={{ width: '100%', boxSizing: 'border-box', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
            </div>

            <div style={{ flex: 1 }}>
              <label><strong>Kota Tujuan</strong></label>
              <input type="text" readOnly value={kotaTujuan} style={{ width: '100%', boxSizing: 'border-box', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label><strong>Keterangan</strong></label>
            <textarea value={keterangan} onChange={(e) => setKeterangan(e.target.value)} rows={3}
              disabled={isLocked}
              style={{ width: '100%', boxSizing: 'border-box', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }} />
          </div>

          {editMode && (
            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
              <div style={{ flex: 1 }}>
                <label><strong>Status</strong></label>
                <input type="text" readOnly value={lstatus} style={{ width: '100%', boxSizing: 'border-box', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
              </div>
              <div style={{ flex: 1 }}>
                <label><strong>Nama TTD1</strong></label>
                <input type="text" readOnly value={namaTtd1} style={{ width: '100%', boxSizing: 'border-box', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
              </div>
            </div>
          )}

          {detailBarang.length > 0 ? (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                <thead style={{ backgroundColor: '#f0f0f0' }}>
                  <tr>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>No.</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>No. SJ</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>No. Shipment</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>Tgl SJ</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>Tgl Masuk</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>Tgl Bongkar</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>Berat</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>Kubik</th>
                    <th style={{ border: '1px solid #ddd', padding: '10px' }}>Karton</th>
                  </tr>
                </thead>

                <tbody>
                  {detailBarang.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.NOMOR}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="text" value={item.NO_SJ} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'NO_SJ', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="text" value={item.NO_SHIPMENT} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'NO_SHIPMENT', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="date" value={item.TGL_SJ} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'TGL_SJ', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="date" value={item.TGL_MASUK} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'TGL_MASUK', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="date" value={item.TGL_BONGKAR} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'TGL_BONGKAR', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="number" step="any" value={item.BERAT} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'BERAT', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', textAlign: 'right', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="number" step="any" value={item.KUBIK} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'KUBIK', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', textAlign: 'right', border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <input type="number" step="1" value={item.KARTON} disabled={isLocked}
                          onChange={(e) => handleDetailChange(index, 'KARTON', e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px', borderRadius: '4px', textAlign: 'right', border: '1px solid #ccc' }} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p style={{ color: '#888' }}>Tidak ada detail.</p>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            {editMode && (
              <>
                <button
                  onClick={handleUnvalid}
                  disabled={!['5', '9'].includes(status)}
                  style={{ backgroundColor: !['5', '9'].includes(status) ? '#A5D6A7' : 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}
                >
                  Un-valid
                </button>
                <button
                  onClick={handleDelete}
                  disabled={isLocked}
                  style={{ backgroundColor: isLocked ? '#A5D6A7' : 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}
                >
                  Delete
                </button>
              </>
            )}
            <button
              onClick={onCancel}
              style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}
            >
              Batal
            </button>
            <button
              onClick={handleValidasi}
              disabled={isLocked}
              style={{
                backgroundColor: isLocked ? '#A5D6A7' : 'green',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
              }}
            >
              Valid
            </button>
      </div>
    </div>
  );
}

export default InputSj;
